let _ = t => t,
  _t;
import { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped
import { getTrack } from '../../selectors/trackSelectors';
// @ts-expect-error untyped
import { getLesson } from '../../selectors/lessonSelectors';
import UsageTracker from '../../utils/UsageTracker';
import { RouterSelectSingle } from '../../features/filters';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import MobileFilterSingleSelect from '../TracksPage/MobileFilterSingleSelect';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { CardMenuIcon, MenuButton } from '../../features/cardMenu';
import { parse } from 'hub-http/helpers/params';
import { HasParentPlaylist, PlaylistNavigationDropdown } from '../../features/playlistContent';
import { SocialShareDropdown } from '../../features/share';
import { DesktopRatingsContainer } from '../../features/ratingsAndReview';
import { useLessonProgressById, useTrackProgressById } from '../../features/userProgress';
import { AcademyRatingsTypes } from '../../constants/RatingsAndReviewConstants';
import { useIsHubspotPlaylist, usePlaylist } from '../../features/savedItems';
import { ContentLanguageSwitcher, MobileContentLanguageSwitcher } from './LanguageSwitcher';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { DownloadIcon, LanguageIcon } from 'foundations-assets';
import { View } from 'foundations-components/transitional/components/View';
import { H2 } from 'foundations-components/transitional/components/H2';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import styledWithTheme from 'foundations-theming/utils';
import RequestLanguageButton from './RequestLanguageButton';
import { MenuLabel } from '../../features/cardMenu/components/MobileCardMenu';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LanguageContainer = styledWithTheme.span(_t || (_t = _`
  white-space: nowrap;
`));
const VerticalRuleDivider = props => {
  return /*#__PURE__*/_jsx(View, Object.assign({
    as: "span",
    blockSize: "30px",
    borderInlineEndColor: "border-core-default",
    borderInlineEndStyle: "solid",
    borderInlineEndWidth: "100",
    marginInlineEnd: "200",
    position: "relative"
  }, props));
};

/**
 * The percentage of progress before we show the ratings container
 */
const RATINGS_CONTAINER_MIN_PROGRESS_LEVEL = 10;
const LearningPageHeader = ({
  ContentName,
  additionalTrackingData,
  availableLanguages,
  trackId,
  language,
  lessonId,
  title,
  studyGuide,
  languageLinkedContent
}) => {
  var _trackProgressById$pr, _lessonProgressById$p;
  const {
    pathname,
    search,
    state
  } = useLocation();
  const {
    isLaptop,
    isMobile,
    isTablet
  } = useMediaQuery();
  const [backLink, setBackLink] = useState('');
  const {
    lessonId: lessonIdParam
  } = useParams();
  const params = parse(search.slice(1));
  const lessonIdWithinTrack = Number(lessonIdParam);
  const {
    trackProgressByIdRefetch,
    trackProgressById
  } = useTrackProgressById(trackId ? Number(trackId) : undefined);
  const {
    lessonProgressByIdRefetch,
    lessonProgressById
  } = useLessonProgressById(lessonId ? Number(lessonId) : undefined);
  useEffect(() => {
    /**
     * Since the progress queries only check for updates on lessonId/trackId, it will only check for progress once
     * We need to refetch the queries when the user navigates around the lesson to keep the progress updated
     */
    if (trackId) void trackProgressByIdRefetch();
    if (lessonId) void lessonProgressByIdRefetch();
  }, [pathname, trackId, lessonId, trackProgressByIdRefetch, lessonProgressByIdRefetch]);
  const showRatings = !isLaptop && (((_trackProgressById$pr = trackProgressById === null || trackProgressById === void 0 ? void 0 : trackProgressById.progressLevel) !== null && _trackProgressById$pr !== void 0 ? _trackProgressById$pr : 0) >= RATINGS_CONTAINER_MIN_PROGRESS_LEVEL || ((_lessonProgressById$p = lessonProgressById === null || lessonProgressById === void 0 ? void 0 : lessonProgressById.progressLevel) !== null && _lessonProgressById$p !== void 0 ? _lessonProgressById$p : 0) >= RATINGS_CONTAINER_MIN_PROGRESS_LEVEL);
  const ratingsReviewType = trackId ? AcademyRatingsTypes.ACADEMY_COURSE : AcademyRatingsTypes.ACADEMY_LESSON;
  const trackDownloadStudyGuide = useCallback(() => {
    UsageTracker.track('interaction', {
      action: 'learning-header-study-guide-click',
      trackId,
      language,
      lessonId,
      title
    });
  }, [trackId, language, lessonId, title]);
  if (!backLink && state !== null && state !== void 0 && state.backLocation) setBackLink(state.backLocation);
  const WithIdsRequestLanguageButton = useCallback(props => /*#__PURE__*/_jsx(RequestLanguageButton, Object.assign({
    lessonId: lessonId,
    trackId: trackId
  }, props)), [trackId, lessonId]);
  const item = {
    id: Number(trackId || lessonId),
    type: trackId ? 'TRACK' : 'LESSON',
    language
  };
  const playlistId = Number(params.playlistId);
  const itemWithPlaylist = Object.assign({}, item, {
    playlistId
  });
  const {
    playlist
  } = usePlaylist(Number(playlistId), !playlistId);
  const isHubspotPlaylist = useIsHubspotPlaylist(playlist);
  const shareItem = trackId && lessonIdWithinTrack ? {
    id: lessonIdWithinTrack,
    type: 'LESSON',
    playlistId,
    trackId: Number(trackId),
    language
  } : {
    id: Number(trackId || lessonId),
    type: trackId ? 'TRACK' : 'LESSON',
    playlistId,
    language
  };
  const ratingsAdditionalTrackingData = Object.assign({}, additionalTrackingData, {
    progressLevel: (trackProgressById === null || trackProgressById === void 0 ? void 0 : trackProgressById.progressLevel) || (lessonProgressById === null || lessonProgressById === void 0 ? void 0 : lessonProgressById.progressLevel),
    isHubspotPlaylist
  }, playlist && {
    playlistId,
    playlistName: playlist.name
  });
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-default",
    borderBlockEndColor: "border-core-default",
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    insetBlockStart: "0",
    margin: "0",
    paddingBlock: "400",
    paddingInline: isTablet ? '300' : '600',
    position: "sticky",
    zIndex: 2,
    children: /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      direction: "row",
      wrap: "nowrap",
      children: [/*#__PURE__*/_jsxs(TFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(HasParentPlaylist, {
          children: /*#__PURE__*/_jsx(PlaylistNavigationDropdown, {
            item: itemWithPlaylist
          })
        }), /*#__PURE__*/_jsx(H2, {
          margin: "0",
          minInlineSize: "90%",
          typography: isMobile ? 'body-200' : undefined,
          children: title || /*#__PURE__*/_jsx(SkeletonText, {})
        }), /*#__PURE__*/_jsx(H2, {
          color: "text-core-subtle",
          margin: "0",
          marginInlineStart: "25",
          typography: isMobile ? 'detail-100' : 'body-100',
          children: ContentName
        })]
      }), isMobile ? /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "100",
        children: /*#__PURE__*/_jsx(CardMenuIcon, {
          item: item,
          itemToShare: shareItem.playlistId || shareItem.trackId ? shareItem : undefined,
          placement: "bottom left",
          renderExtraOptions: setIsOpen => {
            return (
              /*#__PURE__*/
              /* eslint-disable-next-line react/no-unknown-property */
              // @ts-expect-error used in child component
              _jsxs("div", {
                nestedOptions: true,
                children: [!!studyGuide && /*#__PURE__*/_jsx(MenuButton, {
                  "data-test-id": "track-studyguide-button",
                  external: true,
                  href: studyGuide,
                  iconProps: {
                    color: 'icon-core-subtle'
                  },
                  onClick: () => {
                    trackDownloadStudyGuide();
                    setIsOpen(false);
                    window.open(studyGuide, '_blank'); // XAVI: preventDefault in CardMenuIcon is preventing external links from opening. We will remove this once the menu is refactored to use the right components
                  },
                  size: "small",
                  target: "_blank",
                  use: "link",
                  children: /*#__PURE__*/_jsx(MenuLabel, {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "learningCenter.resourcesList.downloadStudyGuide"
                    })
                  })
                }), /*#__PURE__*/_jsx(MenuButton
                // @ts-expect-error Untyped
                , {
                  subpage: languageLinkedContent ? /*#__PURE__*/_jsx(MobileContentLanguageSwitcher, {
                    defaultValue: language.toUpperCase(),
                    languageLinkedContent: languageLinkedContent,
                    lessonId: lessonId ? Number(lessonId) : undefined,
                    onSelect: () => setIsOpen(false),
                    trackId: trackId ? Number(trackId) : undefined
                  }) : /*#__PURE__*/_jsx(MobileFilterSingleSelect, {
                    allowList: availableLanguages,
                    defaultItem: language.toUpperCase(),
                    filterType: FILTER_TYPES.LANGUAGE,
                    lessonId: lessonId ? Number(lessonId) : undefined,
                    onSelect: () => setIsOpen(false),
                    paddingBlock: "300",
                    paddingInline: "500",
                    trackId: trackId ? Number(trackId) : undefined
                  }),
                  use: "unstyled",
                  children: /*#__PURE__*/_jsxs(MenuLabel, {
                    withChevron: true,
                    children: [I18n.text('learningCenter.topFilters.language.filterTitle'), ":", ' ', LanguageNames[language.toLowerCase()]]
                  })
                })]
              })
            );
          }
        })
      }) : /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        direction: "row",
        gap: 30,
        inlineSize: "auto",
        justify: "end",
        wrap: "nowrap",
        children: [showRatings && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(DesktopRatingsContainer, {
            additionalTrackingData: ratingsAdditionalTrackingData,
            contentId: Number(trackId || lessonId),
            reviewType: ratingsReviewType
          }), /*#__PURE__*/_jsx(VerticalRuleDivider, {})]
        }), /*#__PURE__*/_jsxs(LanguageContainer, {
          children: [/*#__PURE__*/_jsx(IconHolder, {
            color: "icon-core-subtle",
            icon: LanguageIcon,
            insetBlockStart: "5px",
            padding: "0",
            position: "relative",
            size: "500"
          }), languageLinkedContent ? /*#__PURE__*/_jsx(ContentLanguageSwitcher, {
            defaultValue: language.toUpperCase(),
            languageLinkedContent: languageLinkedContent,
            menuStyle: {
              maxHeight: '270px'
            },
            menuWidth: "auto",
            optionComponent: WithIdsRequestLanguageButton
          }) : /*#__PURE__*/_jsx(RouterSelectSingle, {
            allowList: availableLanguages,
            defaultItem: language.toUpperCase(),
            filterType: FILTER_TYPES.LANGUAGE,
            menuStyles: {
              maxBlockSize: '270px'
            },
            menuWidth: "auto",
            optionComponent: WithIdsRequestLanguageButton,
            paddingInlineEnd: "0 !important",
            trackingKey: "language-switcher"
          })]
        }), /*#__PURE__*/_jsx(VerticalRuleDivider, {
          marginInlineEnd: "100"
        }), !!trackId && studyGuide && /*#__PURE__*/_jsx(IconButton, {
          "data-test-id": "track-studyguide-button",
          href: studyGuide,
          onClick: trackDownloadStudyGuide,
          placement: "bottom",
          target: "_blank",
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.resourcesList.downloadStudyGuide"
          }),
          use: "link",
          children: /*#__PURE__*/_jsx(IconHolder, {
            color: "icon-core-subtle",
            icon: DownloadIcon,
            padding: "0",
            size: "800"
          })
        }), /*#__PURE__*/_jsx(CardMenuIcon, {
          item: item,
          placement: "bottom left"
        }), /*#__PURE__*/_jsx(SocialShareDropdown, {
          item: shareItem
        })]
      })]
    })
  });
};
const mapStateToProps = () => {
  return (state, {
    trackId,
    lessonId
  }) => {
    let track;
    let title;
    let studyGuide;
    if (trackId) {
      track = getTrack(state, {
        trackId
      });
      title = track && track.get('name');
      studyGuide = track && track.get('studyGuide');
    } else {
      const lesson = getLesson(state, {
        lessonId
      });
      title = lesson.get('name');
    }
    return {
      title,
      studyGuide
    };
  };
};
export default connect(mapStateToProps)(LearningPageHeader);